// extracted by mini-css-extract-plugin
module.exports = {"blog-posts":"BlogPosts_blog-posts__x_S_8","swiper-pagination":"BlogPosts_swiper-pagination__xB_B9","swiper":"BlogPosts_swiper__H1QyN"};